import React from 'react';
import { View } from '../view';
import styles from './panel-content.module.scss';

interface Props {
  alternate?: boolean;
}

export const PanelContent: React.FC<Props> = ({ children, alternate }) => (
  <View className={`${styles.content} ${alternate ? styles.alternate : ''}`}>{children}</View>
);
